__turbopack_context__.v({
  "avatar": "Avatar-module__rkyxdG__avatar",
  "avatarFirm": "Avatar-module__rkyxdG__avatarFirm",
  "avatarGroup": "Avatar-module__rkyxdG__avatarGroup",
  "avatarMe": "Avatar-module__rkyxdG__avatarMe",
  "avatarUser": "Avatar-module__rkyxdG__avatarUser",
  "avatar__img": "Avatar-module__rkyxdG__avatar__img",
  "avatar__initialsSvg": "Avatar-module__rkyxdG__avatar__initialsSvg",
});
